export default __webpack_public_path__ + "static/media/subscriptionCardIcon2.de426676.svg";